import { Button, Card, Col, Container, Form, Row, Table } from "react-bootstrap";
import { FaXmark } from "react-icons/fa6";
import { useEffect, useState } from "react";
import Moment from "react-moment";
import { DataNotFound, WaveLoader } from "../../../Hooks/PageLoader";
import { loginActivitiesServices } from "../../../APIServices/UserData/loginActivitiesServices";
import Swal from "sweetalert2";
import { FaChrome, FaEdge, FaFirefoxBrowser, FaInternetExplorer, FaOpera } from "react-icons/fa";
import { BsBrowserSafari, BsGlobeAmericas } from "react-icons/bs";
import { SiTorbrowser } from "react-icons/si";

const BruteForceAttackRecord = ({auth}) => {
  const [loader, setLoader] = useState(false)
  const [actionLoader, setActionLoader] = useState("")

  const [historyList, setHistoryList] = useState([])
  const [historyCount, setHistoryCount] = useState(0)

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(15);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(historyCount / itemsPerPage);

  const getBruteForceAttackRecord = async () => {
    setLoader(true)
    let data = await loginActivitiesServices.getBruteForceAttackRecord(auth, "my", pageNumber, itemsPerPage)
    if (data === "AbortError") {
      setLoader(true);
    } else {
      setHistoryList(data?.data || [])
      setHistoryCount(data?.count || 0)
      setLoader(false)
    }
  }

  const updateStatusBruteForceAttackedDevice = async (id, clientIp, deviceFingerprint, status) => {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you want to ${status === "active" ? "Remove from" : "Add to"} Blacklist this device?`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${status === "active" ? "Remove" : "Add"} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setActionLoader(id)
        let userData = { clientIp, deviceFingerprint, status };
        let data = await loginActivitiesServices.updateStatusBruteForceAttackedDevice(auth, userData);
        if (data?.statusCode === 200) {
          getBruteForceAttackRecord();
        }
        setActionLoader("")
      }
    });
  };
  useEffect(() => {
    getBruteForceAttackRecord();
  }, []);

  const getLocation = (deviceInfo) => {
    const parts = [
      deviceInfo?.city || "",
      deviceInfo?.regionName || "",
      deviceInfo?.country || "",
      deviceInfo?.zip || "",
    ]
      .map(v => v?.toString().trim())
      .filter(v => v);
    return parts.length ? parts.join(", ") : "Unknown location";
  };

  const getBrowserIcon = (browserName) => {
    if (browserName === "Chrome") return <FaChrome />;
    if (browserName === "Edge") return <FaEdge className="text-primary" />;
    if (browserName === "Firefox") return <FaFirefoxBrowser className="text-warning" />;
    if (browserName === "Opera") return <FaOpera className="text-danger" />;
    if (browserName === "Safari") return <BsBrowserSafari className="text-primary" />;
    if (browserName === "Internet Explorer") return <FaInternetExplorer className="text-primary" />;
    if (browserName === "Tor Browser") return <SiTorbrowser />;
    return <BsGlobeAmericas />;
  };
  return (
    <>
      <div className="w-75 m-auto pb-1 pt-3">
        <h5 className="fw-bold mb-1">Brute Force Attack</h5>
      </div>
      <div className="overflow-auto" style={{ height: "calc(100vh - 48px)" }}>
        {loader ? <WaveLoader /> : historyList?.length === 0 ? <DataNotFound msg={`Link device not found.`} /> :
          <div className="w-75 m-auto py-3">
            <Card className="border rounded-1 mb-3">
              <Card.Body>
                <Container fluid>
                  {historyList?.map((item, index) => {
                    const deviceInfo = item?.deviceInfo || {};
                    const browser = deviceInfo?.browser || {};
                    const os = deviceInfo?.os || {};
                    const device = deviceInfo?.device || {};

                    return (
                      <Row className="my-3 align-items-center" key={item._id || index}>
                        <Form.Group as={Col} md={5}>
                          <div className="d-flex gap-2 align-items-start">
                            <span style={{ fontSize: 24 }} className="text-muted">
                              {getBrowserIcon(browser?.name)}
                            </span>
                            <div style={{ lineHeight: 1.3 }}>
                              <h6 className="mb-1 fw-bold" style={{ fontSize: 14 }}>
                                {browser?.name || "Unknown Browser"}
                                {browser?.version && (<span style={{ fontSize: 11 }}> v.{browser?.version}</span>)}
                              </h6>
                              <Form.Label className="m-0 d-block" style={{ fontSize: 11 }}>
                                {os?.name || "Unknown OS"} {os?.version}{" "}
                                <span className="text-capitalize">
                                  ({device?.type || "device"})
                                </span>
                              </Form.Label>
                              <Form.Label className="mb-0" style={{ fontSize: 11 }}>
                                Attack Date Time: {" "}
                                <Moment format="DD MMM YYYY | HH:mm" withTitle>
                                  {item?.createdAt}
                                </Moment>
                              </Form.Label>
                            </div>
                          </div>
                        </Form.Group>
                        <Form.Group as={Col} md={4}>
                          <div style={{ lineHeight: 1.3 }}>
                            <Form.Label className="m-0 d-block" style={{ fontSize: 11 }}>
                              IP: {deviceInfo?.ipAddress || "N/A"}
                            </Form.Label>
                            <Form.Label className="m-0 d-block" style={{ fontSize: 11 }}>
                              {getLocation(deviceInfo)}
                            </Form.Label>
                            <Form.Label className="mb-0" style={{ fontSize: 11 }}>
                              Timezone: {deviceInfo?.timezone || "Unknown"}
                            </Form.Label>
                          </div>
                        </Form.Group>
                        <Form.Group as={Col} md={3}>
                          <div style={{ fontSize: 13 }} className={`fw-bold`}>
                            <Form.Label className="mb-1 text-center text-muted" style={{ fontSize: 11 }}>
                              No of Attack: {item?.loginAttempted || 0}
                            </Form.Label>
                            <Button
                              variant={
                                item?.status === "active"
                                  ? "outline-danger"
                                  : "outline-success"
                              }
                              className="rounded-1 text-nowrap py-1 px-2"
                              style={{ fontSize: 11 }}
                              disabled={!!actionLoader}
                              onClick={() => updateStatusBruteForceAttackedDevice(item?._id, item?.deviceInfo?.ipAddress, item?.deviceFingerprint, item?.status === "active" ? "blacklist" : "active")}
                            >
                              {item?.status === "active" ? "Add to blacklist" : "Remove from blacklist"}
                            </Button>
                          </div>
                        </Form.Group>
                      </Row>
                    );
                  })}
                </Container>
              </Card.Body>
            </Card>
          </div>
        }
      </div>
    </>
  );
};

export default BruteForceAttackRecord;
